import { Typography } from '@mui/material';

type CustomNoRowsOverlayProps = {
    title: string;
    useCustomTitle?: boolean;
}

const CustomNoRowsOverlay = (
    { title, useCustomTitle = false }: CustomNoRowsOverlayProps
) => {
    const customTitle = useCustomTitle ? title : title.toLowerCase();
    const noRowsCustomContent = `No ${customTitle} have been added yet`;

    return (
        <Typography
            color='text.secondary'
            fontSize='16px'
            variant='body1'
            marginTop='26px'
        >
            {noRowsCustomContent}
        </Typography>
    );
};

export { CustomNoRowsOverlay };
